import * as z from "zod/mini";

export const gigSidebarSchema = z.object({
  selected_gig_id: z.optional(z.number()),
  selected_pro_id: z.optional(z.number()),
});
